import AxiosServices from "./AxiosService";

const Auth = new AxiosServices();


class LiveSessionsService {

    AddLiveSession = async (liveSession) => {
        return Auth.post('/live-sessions', liveSession)
    };

    GetLiveSessions = async () => {
        return Auth.get('/live-sessions')
    };

    GetLiveSessionById = async (id) => {
        return Auth.get(`/live-sessions/${id}`)
    };

    CancelLiveSession = async (id) => {
        return Auth.post(`/live-sessions/${id}/cancel`)
    };

    JoinLive = async (id) => {
        return Auth.post(`/live-sessions/${id}/join`)
    };

}

export default LiveSessionsService

